export default "__VITE_ASSET__BYX2fmOA__"